export default "__VITE_ASSET__CXIHmXon__"